import { FactorType } from 'api/auth/mfa'
import { sendMfaFactorChallenge } from 'api/user/mfa'

export default async function requestChallenge(
    factorId: FactorType,
): Promise<unknown> {
    return sendMfaFactorChallenge(factorId)
}
